import React from 'react';

import { useHistory } from 'react-router-dom';

import { User } from '../../../generated/graphql';
import { IPeopleInnerProps } from '../People';

import { TableBody, TableHead } from '@material-ui/core';

import {
  PeopleTableRowsWrapper,
  PeopleTableContentCell,
  PeopleTableHeaderTitle,
  PeopleTableHeadRow,
  PeopleTableContentRow,
  PeopleTableNoUsersRow
} from '../People.style';

import { UserMenu } from '../../shared/Options/UserMenu';

import { DEFAULT_AVATAR_URL } from '../../shared/constants';
import { UserAvatarStyle, UserAvatarDefaultStyle } from '../../shared/Style/Style';


export const Staff = ({ noData, users, getUserData }: IPeopleInnerProps) => {
  interface IHeader {
    title: string;
    maxWidth?: string;
  }

  const headers: IHeader[] = [
    { title: 'Фото' },
    { title: 'Фамилия' },
    { title: 'Имя' },
    { title: 'Профессия' },
    { title: 'Статус' },
    { title: 'Текущая задача' },
    {
      title: '',
      maxWidth: '48px',
    },
  ];

  const history = useHistory();

  return (
    <>
      <TableHead>
        <PeopleTableHeadRow columns={headers.length - 1}>
          {headers.map((header: IHeader) => (
            <PeopleTableHeaderTitle
              style={{ maxWidth: `${header.maxWidth ? header.maxWidth : 'unset' } ` }}
              key={header.title}
            >
              {header.title}
            </PeopleTableHeaderTitle>
          ))}
        </PeopleTableHeadRow>
      </TableHead>

      <TableBody>
        <PeopleTableRowsWrapper>

        {users?.length
          ? users?.map((user: User) => (
            <PeopleTableContentRow
              key={user.id}
              columns={headers.length - 1}
              onClick={() => history.push(`/user/${user.id}/edit`)}
            >
              {!!user?.photo ? (
                <UserAvatarStyle
                  prim={user.photo ? user.photo : undefined}
                  alt=" "
                />
              ) : (
                <UserAvatarDefaultStyle src={DEFAULT_AVATAR_URL} alt=" " />
              )}

              {[user.lastName, user.firstName, user.job?.name, user.position?.displayName ].map((field, i) => (
                <PeopleTableContentCell key={i}>{field ? field : noData}</PeopleTableContentCell>
              ))}

              <PeopleTableContentCell>{noData}</PeopleTableContentCell>

              <PeopleTableContentCell>
                <UserMenu
                  user={user}
                  getUserData={getUserData}
                />
              </PeopleTableContentCell>
            </PeopleTableContentRow>
          ))
          : (
            <PeopleTableNoUsersRow>
              <PeopleTableContentCell>
                Пользователи отсутствуют
              </PeopleTableContentCell>
            </PeopleTableNoUsersRow>
          )}
        </PeopleTableRowsWrapper>

      </TableBody>
    </>
  )
}
